import { Constants } from 'utils';

const conversion = (state = 1, action: any) => {
	switch(action.type) {
		case 'SET_CONVERSION':
            return action.payload;
            break;
        default: 
        	return state;
        	break;
	}
}

export default conversion;